"use client";

import { Footer } from "@/components/footer";
import { Tiktok } from "@/components/page/tiktok";
import { Platform } from "@/components/page/liveStreaming/platform";
import { TiktokPPage } from "@/components/page/tiktok/tiktok";
import { Demand } from "@/components/page/tiktok/demand";
import { Region } from "@/components/page/tiktok/region";
import { Cases } from "@/components/page/tiktok/cases";
import { AutofitPageWrapper } from "@/components/AutofitPageWrapper";
import { useIsMobile } from "@/app/hooks/useIsMobile";
import { MobileFooter } from "@/components/mobile-footer";
import { HeaderMobile } from "@/components/header-mobile";
import { TiktokMobileFirst } from "@/components/page/tiktok-mobile/first";
import { TiktokMobileSecond } from "@/components/page/tiktok-mobile/second";
import { TiktokMobileThree } from "@/components/page/tiktok-mobile/three";
import TiktokMobileFourth from "@/components/page/tiktok-mobile/fourth";
import { TiktokMobileFive } from "@/components/page/tiktok-mobile/five";

export default function TiktokPageClient() {
  const isMobile = useIsMobile();

  if (isMobile === null)
    return (
      <div
        className="w-screen h-screen"
        style={{ background: "linear-gradient(135deg, rgba(236,245,255,1) 2.885%, rgba(185,242,250,1) 56.731%, rgba(110,201,255,1) 97.596%)" }}
      />
    );

  if (isMobile) {
    return (
      <div className="flex flex-col w-full h-screen overflow-y-auto">
        <HeaderMobile />
        <TiktokMobileFirst />
        <TiktokMobileSecond />
        <TiktokMobileThree />
        <TiktokMobileFourth />
        <TiktokMobileFive />
        <MobileFooter />
        <div className="h-[20px] min-h-[20px]" />
      </div>
    );
  }

  return (
    <AutofitPageWrapper>
      <Tiktok />
      <Platform />
      <TiktokPPage />
      <Demand />
      <Region />
      <Cases />
      <Footer />
    </AutofitPageWrapper>
  );
}
